import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { toast } from "sonner";
import { Label } from "@/components/ui/label";

export const ApplicationDialog = ({ 
  application, 
  onClose,
  onUpdate 
}: { 
  application: any;
  onClose: () => void;
  onUpdate: () => void;
}) => {
  const [adminNotes, setAdminNotes] = useState(application?.admin_notes || "");
  const [certNumber, setCertNumber] = useState(application?.cert_number || "");

  const updateApplication = async (status: string) => {
    if (!application) return;

    const { error } = await supabase
      .from('cert_applications')
      .update({
        status,
        admin_notes: adminNotes,
        cert_number: certNumber,
        reviewed_at: new Date().toISOString(),
        reviewed_by: 'admin'
      })
      .eq('id', application.id);

    if (error) {
      toast.error("更新状态失败");
    } else {
      toast.success("更新状态成功");
      onUpdate();
      onClose();
    }
  };

  if (!application) return null;

  return (
    <Dialog open={!!application} onOpenChange={() => onClose()}>
      <DialogContent className="bg-gray-900 text-white border-gray-800">
        <DialogHeader>
          <DialogTitle>处理申请</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>备案号码</Label>
            <Input
              value={certNumber}
              onChange={(e) => setCertNumber(e.target.value)}
              className="bg-gray-800 border-gray-700"
            />
          </div>
          <div>
            <Label>管理员备注</Label>
            <Textarea
              value={adminNotes}
              onChange={(e) => setAdminNotes(e.target.value)}
              placeholder="输入处理备注..."
              className="bg-gray-800 border-gray-700"
            />
          </div>
          <div className="flex gap-2">
            <Button
              variant="default"
              className="bg-green-600 hover:bg-green-700"
              onClick={() => updateApplication('approved')}
            >
              通过
            </Button>
            <Button
              variant="destructive"
              onClick={() => updateApplication('rejected')}
            >
              拒绝
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};